import {
  notEmptyListOf1z9dexvzyo0sz as notEmptyListOf,
  NotEmptyList__toList_impl_nbkblo2t03ghtl62atf as NotEmptyList__toList_impl_nbkblo,
  NotEmptyList3lrchpxsqrpb2 as NotEmptyList,
  _NotEmptyList___get_tail__impl__3z1zi8xi5swsbinbh6 as _NotEmptyList___get_tail__impl__3z1zi8,
  _NotEmptyList___get_head__impl__zp2swd74ywavyj2ua as _NotEmptyList___get_head__impl__zp2sw,
  NotEmptyList__toString_impl_vyyy951sraygjh2m8u3 as NotEmptyList__toString_impl_vyyy95,
  NotEmptyList__hashCode_impl_a7t1ga1y0ygqux6pn7k as NotEmptyList__hashCode_impl_a7t1ga,
} from '../../../../../../types-types/kotools/types/collection/NotEmptyList.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  plus310ted5e4i90h as plus,
  joinToString1cxrrlmo0chqs as joinToString,
  first58ocm7j58k3q as first,
  slice2g43wio9c6zdv as slice,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { _get_displayName_$ref_dpnhdf2wlam2j87xunb as _get_displayName_$ref_dpnhdf } from '../player/Player.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { until1jbpn0z3f8lbg as until } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { CallSign1tjdkp2izdbad as CallSign } from '../player/callsign/CallSign.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NotBlankString__toString_impl_5tex9r3bdt5aydt9d7j as NotBlankString__toString_impl_5tex9r } from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SingleClass;
function Single() {
  if (SingleClass === VOID) {
    class $ extends CouplingPair() {
      constructor(player) {
        super();
        this.player_1 = player;
      }
      toNotEmptyList_8celwn_k$() {
        return notEmptyListOf(this.player_1, []);
      }
      toString() {
        return 'Single(player=' + this.player_1.toString() + ')';
      }
      hashCode() {
        return this.player_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Single()))
          return false;
        if (!this.player_1.equals(other.player_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Single');
    SingleClass = $;
  }
  return SingleClass;
}
var DoubleClass;
function Double() {
  if (DoubleClass === VOID) {
    class $ extends CouplingPair() {
      constructor(player1, player2) {
        super();
        this.player1__1 = player1;
        this.player2__1 = player2;
      }
      toNotEmptyList_8celwn_k$() {
        return notEmptyListOf(this.player1__1, [this.player2__1]);
      }
      toString() {
        return 'Double(player1=' + this.player1__1.toString() + ', player2=' + this.player2__1.toString() + ')';
      }
      hashCode() {
        var result = this.player1__1.hashCode();
        result = imul(result, 31) + this.player2__1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Double()))
          return false;
        if (!this.player1__1.equals(other.player1__1))
          return false;
        if (!this.player2__1.equals(other.player2__1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Double');
    DoubleClass = $;
  }
  return DoubleClass;
}
var MobClass;
function Mob() {
  if (MobClass === VOID) {
    class $ extends CouplingPair() {
      constructor(player1, player2, player3, more) {
        super();
        this.player1__1 = player1;
        this.player2__1 = player2;
        this.player3__1 = player3;
        this.more_1 = more;
      }
      toNotEmptyList_8celwn_k$() {
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = plus(listOf([this.player2__1, this.player3__1]), this.more_1);
        var tmp$ret$0 = copyToArray(this_0);
        return notEmptyListOf(this.player1__1, tmp$ret$0.slice());
      }
      toString() {
        return 'Mob(player1=' + this.player1__1.toString() + ', player2=' + this.player2__1.toString() + ', player3=' + this.player3__1.toString() + ', more=' + toString(this.more_1) + ')';
      }
      hashCode() {
        var result = this.player1__1.hashCode();
        result = imul(result, 31) + this.player2__1.hashCode() | 0;
        result = imul(result, 31) + this.player3__1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.more_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Mob()))
          return false;
        if (!this.player1__1.equals(other.player1__1))
          return false;
        if (!this.player2__1.equals(other.player2__1))
          return false;
        if (!this.player3__1.equals(other.player3__1))
          return false;
        if (!equals(this.more_1, other.more_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Mob');
    MobClass = $;
  }
  return MobClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var CouplingPairClass;
function CouplingPair() {
  if (CouplingPairClass === VOID) {
    class $ {
      asArray_cev8hl_k$() {
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = NotEmptyList__toList_impl_nbkblo(this.toNotEmptyList_8celwn_k$());
        return copyToArray(this_0);
      }
      iterator_jk1svi_k$() {
        return NotEmptyList__toList_impl_nbkblo(this.toNotEmptyList_8celwn_k$()).iterator_jk1svi_k$();
      }
    }
    initMetadataForClass($, 'CouplingPair');
    CouplingPairClass = $;
  }
  return CouplingPairClass;
}
function get_pairId(_this__u8e3s4) {
  return joinToString(_this__u8e3s4, '-', VOID, VOID, VOID, VOID, _get_pairId_$lambda_m5yvaj);
}
function get_pairName(_this__u8e3s4) {
  var tmp = KProperty1();
  return joinToString(_this__u8e3s4, '-', VOID, VOID, VOID, VOID, getPropertyCallableRef('displayName', 1, tmp, _get_displayName_$ref_dpnhdf(), null));
}
function toCouplingPair(_this__u8e3s4) {
  switch (_this__u8e3s4.get_size_woubt6_k$()) {
    case 1:
      return new (Single())(first(_this__u8e3s4));
    case 2:
      return new (Double())(_this__u8e3s4.get_c1px32_k$(0), _this__u8e3s4.get_c1px32_k$(1));
    default:
      return new (Mob())(_this__u8e3s4.get_c1px32_k$(0), _this__u8e3s4.get_c1px32_k$(1), _this__u8e3s4.get_c1px32_k$(2), toSet(slice(_this__u8e3s4, until(3, _this__u8e3s4.get_size_woubt6_k$()))));
  }
}
function pairOf(player1) {
  return new (Single())(player1);
}
var PinnedCouplingPairClass;
function PinnedCouplingPair() {
  if (PinnedCouplingPairClass === VOID) {
    class $ {
      constructor(pinnedPlayers, pins) {
        pins = pins === VOID ? emptySet() : pins;
        this.pinnedPlayers_1 = pinnedPlayers;
        this.pins_1 = pins;
      }
      toPair_eddkwb_k$() {
        // Inline function 'kotlin.with' call
        var $this$with = this.pinnedPlayers_1;
        var tail = _NotEmptyList___get_tail__impl__3z1zi8($this$with);
        var tmp;
        var tmp_0 = tail;
        if ((tmp_0 == null ? null : new (NotEmptyList())(tmp_0)) == null) {
          tmp = pairOf(_NotEmptyList___get_head__impl__zp2sw($this$with).player_1);
        } else {
          tmp = pairOf_0(_NotEmptyList___get_head__impl__zp2sw($this$with).player_1, _NotEmptyList___get_head__impl__zp2sw(tail).player_1);
        }
        return tmp;
      }
      copy_37ogvq_k$(pinnedPlayers, pins) {
        return new (PinnedCouplingPair())(pinnedPlayers, pins);
      }
      copy$default_pccw8i_k$(pinnedPlayers, pins, $super) {
        pinnedPlayers = pinnedPlayers === VOID ? this.pinnedPlayers_1 : pinnedPlayers;
        pins = pins === VOID ? this.pins_1 : pins;
        return $super === VOID ? this.copy_37ogvq_k$(pinnedPlayers, pins) : $super.copy_37ogvq_k$.call(this, new (NotEmptyList())(pinnedPlayers), pins);
      }
      toString() {
        return 'PinnedCouplingPair(pinnedPlayers=' + NotEmptyList__toString_impl_vyyy95(this.pinnedPlayers_1) + ', pins=' + toString(this.pins_1) + ')';
      }
      hashCode() {
        var result = NotEmptyList__hashCode_impl_a7t1ga(this.pinnedPlayers_1);
        result = imul(result, 31) + hashCode(this.pins_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedCouplingPair()))
          return false;
        if (!equals(new (NotEmptyList())(this.pinnedPlayers_1), new (NotEmptyList())(other.pinnedPlayers_1)))
          return false;
        if (!equals(this.pins_1, other.pins_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedCouplingPair');
    PinnedCouplingPairClass = $;
  }
  return PinnedCouplingPairClass;
}
var PinnedPlayerClass;
function PinnedPlayer() {
  if (PinnedPlayerClass === VOID) {
    class $ {
      constructor(player, pins) {
        this.player_1 = player;
        this.pins_1 = pins;
      }
      copy_vwr0xl_k$(player, pins) {
        return new (PinnedPlayer())(player, pins);
      }
      copy$default_azdh9x_k$(player, pins, $super) {
        player = player === VOID ? this.player_1 : player;
        pins = pins === VOID ? this.pins_1 : pins;
        return $super === VOID ? this.copy_vwr0xl_k$(player, pins) : $super.copy_vwr0xl_k$.call(this, player, pins);
      }
      toString() {
        return 'PinnedPlayer(player=' + this.player_1.toString() + ', pins=' + toString(this.pins_1) + ')';
      }
      hashCode() {
        var result = this.player_1.hashCode();
        result = imul(result, 31) + hashCode(this.pins_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayer()))
          return false;
        if (!this.player_1.equals(other.player_1))
          return false;
        if (!equals(this.pins_1, other.pins_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayer');
    PinnedPlayerClass = $;
  }
  return PinnedPlayerClass;
}
function callSign(_this__u8e3s4) {
  var pair = _this__u8e3s4.toPair_eddkwb_k$().toNotEmptyList_8celwn_k$();
  var nounPlayer = _NotEmptyList___get_head__impl__zp2sw(pair);
  var tmp0_safe_receiver = _NotEmptyList___get_tail__impl__3z1zi8(pair);
  var tmp;
  var tmp_0 = tmp0_safe_receiver;
  if ((tmp_0 == null ? null : new (NotEmptyList())(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = _NotEmptyList___get_head__impl__zp2sw(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var adjectivePlayer = tmp1_elvis_lhs == null ? nounPlayer : tmp1_elvis_lhs;
  var adjective = adjectivePlayer.callSignAdjective_1;
  var noun = nounPlayer.callSignNoun_1;
  return new (CallSign())(adjective, noun);
}
function get_players(_this__u8e3s4) {
  // Inline function 'com.zegreatrob.coupling.model.map' call
  var this_0 = _this__u8e3s4.pinnedPlayers_1;
  var tmp = _NotEmptyList___get_head__impl__zp2sw(this_0).player_1;
  var tmp0_safe_receiver = _NotEmptyList___get_tail__impl__3z1zi8(this_0);
  var tmp_0;
  var tmp_1 = tmp0_safe_receiver;
  if ((tmp_1 == null ? null : new (NotEmptyList())(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = NotEmptyList__toList_impl_nbkblo(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(tmp1_safe_receiver, 10));
    var _iterator__ex2g4s = tmp1_safe_receiver.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$4 = item.player_1;
      destination.add_utx5q5_k$(tmp$ret$4);
    }
    tmp_2 = destination;
  }
  var tmp2_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp2_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp2_safe_receiver);
  }
  var tmp3_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  return notEmptyListOf(tmp, tmp_4.slice());
}
function pairOf_0(player1, player2) {
  return new (Double())(player1, player2);
}
function withPins(_this__u8e3s4, pins) {
  pins = pins === VOID ? emptySet() : pins;
  // Inline function 'com.zegreatrob.coupling.model.map' call
  var this_0 = _this__u8e3s4.toNotEmptyList_8celwn_k$();
  var player = _NotEmptyList___get_head__impl__zp2sw(this_0);
  var tmp = withPins_1(player);
  var tmp0_safe_receiver = _NotEmptyList___get_tail__impl__3z1zi8(this_0);
  var tmp_0;
  var tmp_1 = tmp0_safe_receiver;
  if ((tmp_1 == null ? null : new (NotEmptyList())(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = NotEmptyList__toList_impl_nbkblo(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(tmp1_safe_receiver, 10));
    var _iterator__ex2g4s = tmp1_safe_receiver.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$4 = withPins_1(item);
      destination.add_utx5q5_k$(tmp$ret$4);
    }
    tmp_2 = destination;
  }
  var tmp2_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp2_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp2_safe_receiver);
  }
  var tmp3_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  var tmp$ret$0 = notEmptyListOf(tmp, tmp_4.slice());
  return new (PinnedCouplingPair())(tmp$ret$0, pins);
}
function withPins_0(_this__u8e3s4) {
  // Inline function 'com.zegreatrob.coupling.model.map' call
  var p0 = _NotEmptyList___get_head__impl__zp2sw(_this__u8e3s4);
  var tmp = withPins(p0);
  var tmp0_safe_receiver = _NotEmptyList___get_tail__impl__3z1zi8(_this__u8e3s4);
  var tmp_0;
  var tmp_1 = tmp0_safe_receiver;
  if ((tmp_1 == null ? null : new (NotEmptyList())(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = NotEmptyList__toList_impl_nbkblo(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(tmp1_safe_receiver, 10));
    var _iterator__ex2g4s = tmp1_safe_receiver.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$4 = withPins(item);
      destination.add_utx5q5_k$(tmp$ret$4);
    }
    tmp_2 = destination;
  }
  var tmp2_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp2_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(tmp2_safe_receiver);
  }
  var tmp3_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_4 = [];
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  return notEmptyListOf(tmp, tmp_4.slice());
}
function withPins_1(_this__u8e3s4, pins) {
  pins = pins === VOID ? emptyList() : pins;
  return new (PinnedPlayer())(_this__u8e3s4, pins);
}
function _get_pairId_$lambda_m5yvaj(it) {
  return NotBlankString__toString_impl_5tex9r(it.id_1.value_1);
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Double as Double32fogsljf31b1,
  PinnedCouplingPair as PinnedCouplingPair2b955okagel53,
  PinnedPlayer as PinnedPlayer2ydg21cly1nl1,
  callSign as callSignej8g32eqhquf,
  get_pairId as get_pairId17ekbda4ugyhg,
  get_pairName as get_pairName1swn4cuiimab3,
  pairOf_0 as pairOf3vr52fdd2zexd,
  pairOf as pairOf3e832z5sy0jiu,
  get_players as get_players1sz7rz6glqiyb,
  toCouplingPair as toCouplingPair2pztyujdw46m4,
  withPins as withPins10vez28uvca2x,
  withPins_0 as withPins352yl9ie2njao,
};
//endregion

//# sourceMappingURL=CouplingPair.mjs.map
